// extracted by mini-css-extract-plugin
export default {"zr-table":"FulfillmentList_zr-table__73CCQ","table-header":"FulfillmentList_table-header__GTfPu"};